import { userHasAllRights } from "../../../functions/userRights";

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      noFacesList: [".pdf"],
    };
  },
  methods: {
    canEditFaces() {
      return userHasAllRights(["add+delete_faces"], this);
    },
    canEditTags() {
      return userHasAllRights(["add+delete_tags"], this);
    },
    showFace() {
      let present = false;

      this.noFacesList.forEach((ext) => {
        if (ext === this.file.extension) {
          present = true;
        }
      });

      return !present && this.file.thumbnail;
    },
  },
};
